import { render, staticRenderFns } from "./wxRegister.vue?vue&type=template&id=1480ae43&scoped=true&"
import script from "./wxRegister.vue?vue&type=script&lang=ts&"
export * from "./wxRegister.vue?vue&type=script&lang=ts&"
import style0 from "./wxRegister.vue?vue&type=style&index=0&id=1480ae43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480ae43",
  null
  
)

export default component.exports